import * as _ from 'lodash';
import { FormControlBase } from './form-control-base';
import { FormControlData } from './form-control-data';

export class PrimeDropdownControl extends FormControlBase<any> {
  controlType = 'prime-dropdown';
  editable = false;

  constructor(options: FormControlData<any> = {}) {
    super(options);
  }

  protected initialize() {
    if (this.setValueFromModel) {
      this.value = _.get(this.model, this.propertyName);
    }
  }

  commit() {
    if (this.setValueFromModel) {
      const modelValue = _.get(this.model, this.propertyName);
      if (!modelValue && !this.value) {
        return;
      }

      if (this.value === '') {
        _.set(this.model, this.propertyName, undefined);
      } else {
        _.set(this.model, this.propertyName, this.value);
      }
    }
  }
}
